import { ParsedAddress } from "../../dtos/ParsedAddress";
import { AddressAutoCompleteActions } from "./LocalTypes";
import { TOGGLE_SEARCH_STATUS_VALUE, ADDRESS_INPUT_FOCUS, LOAD_LIST_OF_OPTIONS, ON_ITEM_LIST_CLICK, ON_CLOSE_BUTTON } from "./LocalConstants";

interface IAddressAutoCompleteState {
    items: string[],
    itemObject: ParsedAddress[],
    isLoading: boolean,
    value: string,
    focused: boolean,
    selected: boolean
}
export const initialState = (value: string): IAddressAutoCompleteState => ({
    items: [],
    itemObject: [],
    isLoading: false,
    value,
    focused: false,
    selected: true
});

const reducer = (state: IAddressAutoCompleteState, action: AddressAutoCompleteActions): IAddressAutoCompleteState => {
    switch (action.type) {
        case TOGGLE_SEARCH_STATUS_VALUE:
            return Object.assign({}, state, {
                isLoading: action.payload.isSearching
            });
        case ADDRESS_INPUT_FOCUS:
            return Object.assign({}, state, {
                focused: true,
                selected: false
            })
        case LOAD_LIST_OF_OPTIONS:
            return Object.assign({}, state, {
                ...action.payload,
                isLoading: false
            })
        case ON_ITEM_LIST_CLICK:
            return Object.assign({}, state, {
                ...action.payload
            })
        case ON_CLOSE_BUTTON:
            return Object.assign({}, state, {
                isLoading: false,
                focused: false,
                selected: true
            })
        default:
            return state;
    }
}
export default reducer;


// WEBPACK FOOTER //
// ./src/components/AddressAutoComplete/LocalReducer.ts